import ErrorBoundary from '@/components/ErrorBoundary'
import { useEffect, useState } from 'react'
import cx from 'classnames'
import { object, bool } from 'prop-types'
import style from './loading.module.less'

/**
 *
 * @param {object} props
 * @param {boolean} [props.full]
 * @param {object} [props.style]
 * @returns
 */
function ComLoading(props) {
  const { full, style: styles } = props
  const [lineHeight, setLineHeight] = useState(Math.round((window.innerWidth * 4) / 750))
  useEffect(() => {
    window.onresize = () => {
      setLineHeight(Math.round((window.innerWidth * 4) / 750))
    }

    return () => (window.onresize = null)
  }, [])
  return (
    <ErrorBoundary>
      <div className={`${style.loading} ${full ? style.full : ''}`} style={styles}>
        <div className={style.rectangle}>
          <div
            className={cx(style.line1, style.lineAnim)}
            style={{
              height: lineHeight,
            }}
          ></div>
          <div
            className={cx(style.line2, style.lineAnim)}
            style={{
              height: lineHeight,
            }}
          ></div>
          <div
            className={cx(style.line3, style.lineAnim)}
            style={{
              height: lineHeight,
            }}
          ></div>
        </div>
        <div className={style.text}>{'努力加载中'}</div>
        <div className={style.text}>{'···'}</div>
      </div>
    </ErrorBoundary>
  )
}

ComLoading.propTypes = {
  location: object,
  history: object,
  full: bool,
}
export { ComLoading }
export default ComLoading
